export interface Scopus{
    autor: string,
    titulo: string,
    coverDate: string,
    coverDisplayDate: string,
    eid: string,
    publicationName: string,
    volumen: string,
    pageRange: string,
    citedCount: string,
    source: string,
    tipo: string,
    subTipo: string,
    issn: string,
    doi: string,
    openAccess: string,
    prodCoincidencias: Array<ProductoCoincidencias>
}

export function setScopus(data: any):Scopus{
    return{
        autor: data.autor ?? "",
        titulo: data.titulo ?? "",
        coverDate: data.coverDate ?? "1991-01-01",
        coverDisplayDate: data.coverDisplayDate ?? "",
        eid: data.eid ?? "",
        publicationName: data.publicationName ?? "",
        volumen: data.volumen ?? "",
        pageRange: data.pageRange ?? "",
        citedCount: data.citedCount ?? "",
        source: data.source ?? "",
        tipo: data.tipo ?? "",
        subTipo: data.subTipo ?? "",
        issn: data.issn ?? "",
        doi: data.doi ?? "",
        openAccess: data.openAccess ?? "",
        prodCoincidencias: data.proyCoincidencias ?? [] 
    }
}

export interface ProductoCoincidencias{
    coincidenciaDoi: boolean,
    coincidenciaTitulo: boolean,
    doi: string,
    idproducto: number,
    titulo: string 
}